import RulesRequests from '../../server/punchOutN2Rules';
import { addLoading, removeLoading } from './loading';

export const setPunchOutN2Rules = res => ({
  type: 'PANEL_GET_PUNCHOUT_N2_RULES',
  punchOutN2Rules: res,
});

const createPunchOutN2Rule = rule => async (dispatch) => {
  dispatch(addLoading());
  try {
    await RulesRequests.createPunchOutN2Rule(rule);
  } finally {
    dispatch(removeLoading());
  }
};

const updatePunchOutN2Rule = rule => async (dispatch) => {
  dispatch(addLoading());
  try {
    await RulesRequests.updatePunchOutN2Rule(rule);
  } finally {
    dispatch(removeLoading());
  }
};

const getPunchOutN2Rules = (limit, skip, force = false, order = '', field = '') => async (dispatch) => {
  if (force) dispatch(addLoading());
  try {
    const rules = await RulesRequests.getPunchOutN2Rules(limit, skip, order, field);
    dispatch(setPunchOutN2Rules(rules));
  } finally {
    if (force) dispatch(removeLoading());
  }
};

export default {
  createPunchOutN2Rule,
  getPunchOutN2Rules,
  updatePunchOutN2Rule,
};
